import { render, staticRenderFns } from "./PageShutdown.vue?vue&type=template&id=8b7073ba&scoped=true"
import script from "./PageShutdown.vue?vue&type=script&lang=js"
export * from "./PageShutdown.vue?vue&type=script&lang=js"
import style0 from "./PageShutdown.vue?vue&type=style&index=0&id=8b7073ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7073ba",
  null
  
)

export default component.exports